import { render, staticRenderFns } from "./userBinding.vue?vue&type=template&id=9ed35dfc&"
import script from "./userBinding.vue?vue&type=script&lang=js&"
export * from "./userBinding.vue?vue&type=script&lang=js&"
import style0 from "./userBinding.vue?vue&type=style&index=0&id=9ed35dfc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports